<template>
  <div class="container">
    <img src="../../assets/Escape/living_room.png" class="image" />
    <img src="../../assets/Escape/box.png" id="box" class="elements" @click="toggleCode" />
    <img
      src="../../assets/Escape/cegp-enigme.png"
      id="enigme"
      class="elements"
      @click="toggleEnigme"
    />
    <transition name="fade">
      <LivingRoomEnigme
        v-if="displayEnigme"
        class="modale-enigme"
        @close="displayEnigme = false"
      />
    </transition>
    <transition name="fade">
      <LivingRoom2Intro
        v-if="displayLivingRoom2Intro"
        class="modale"
        @close="displayLivingRoom2Intro = false"
      />
    </transition>
    <transition name="fade">
      <Code
        v-if="displayCode"
        class="modale"
        @close="displayCode = false"
        @next="$emit('goToPartFour')"
        :title="'Entrer le code à 4 chiffres :'"
        :password="'3121'"
        :password2="'3122'"
        :length="4"
      />
    </transition>
  </div>
</template>

<script>
import LivingRoomEnigme from "./LivingRoomEnigme.vue";
import LivingRoom2Intro from "./LivingRoom2Intro.vue";
import Code from "./Code.vue";

export default {
  name: "LivingRoom2",
  components: {
    LivingRoomEnigme,
    LivingRoom2Intro,
    Code
  },
  data() {
    return {
      displayLivingRoom2Intro: true,
      displayEnigme: false,
      displayCode: false,
    }
  },
  methods: {
    toggleEnigme() {
      this.displayCode = false
      this.displayLivingRoom2Intro = false
      this.displayEnigme = this.displayEnigme ? false : true
    },
    toggleCode() {
      this.displayEnigme = false
      this.displayLivingRoom2Intro = false
      this.displayCode = this.displayCode ? false : true
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}
.image {
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  cursor: zoom-in;
}
#box {
  position: absolute;
  bottom: 6%;
  right: 50%;
  height: 18%;
}
#enigme {
  position: absolute;
  bottom: 8%;
  right: 40%;
  height: 9%;
}
.elements:hover {
  opacity: 0.8;
  cursor: zoom-in;
}
.modale {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 90%;
  right: 25%;
  width: 50%;
  overflow: scroll;
}
.modale-enigme {
  position: absolute;
  top: 2.5%;
  height: auto;
  max-height: 90%;
  right: 25%;
  width: 50%;
  overflow: scroll;
}
</style>
